import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { LabelsBlock } from '../../commonComponents/CommonComponents'
import { DmcGrid } from '../../../common/DmcGrid'
import { DmcText } from '../../../common/DmcText'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function HistoricalMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const detectedPersonId = messageDetails.matchedPersonId
  const historicalPersonId = messageDetails.searchPersonId
  const contributorId = messageDetails.contributorId

  const detectedPersonSummary = queueCachesState.personsCache[detectedPersonId]
  const historicalPersonSummary = queueCachesState.personsCache[historicalPersonId]
  const detectedPersonLabels = queueCachesState.labelsCache[detectedPersonId]
  const userSummary = queueCachesState.usersCache[contributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(detectedPersonId)
    queueCachesActions.fetchPersonSummary(historicalPersonId)
    queueCachesActions.fetchPersonLabels(detectedPersonId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (
    isNullOrUndefined(detectedPersonSummary) ||
    isNullOrUndefined(detectedPersonLabels) ||
    isNullOrUndefined(userSummary)
  ) {
    return null
  }

  const rows = []
  rows.push({
    label: t('pid', 'PID'),
    detectedPerson: detectedPersonSummary.id ? (
      <>
        <PersonLink personId={detectedPersonSummary.id} forward={false} newTab />
        <TreePersonLink personId={detectedPersonSummary.id} treeIcon newTab />
      </>
    ) : null,
    historicalPerson: historicalPersonSummary.id ? (
      <>
        <PersonLink personId={historicalPersonSummary.id} forward={false} newTab />{' '}
        <TreePersonLink personId={historicalPersonSummary.id} treeIcon newTab />
      </>
    ) : null,
  })
  rows.push({
    label: t('name', 'Name'),
    detectedPerson: detectedPersonSummary?.summary?.name,
    historicalPerson: historicalPersonSummary?.summary?.name,
  })
  rows.push({
    label: t('birthPlace', 'Birth Place'),
    detectedPerson: detectedPersonSummary?.birth?.value?.place?.original,
    historicalPerson: historicalPersonSummary?.birth?.value?.place?.original,
  })
  rows.push({
    label: t('birthDate', 'Birth Date'),
    detectedPerson: detectedPersonSummary?.birth?.value?.date?.original,
    historicalPerson: historicalPersonSummary?.birth?.value?.date?.original,
  })
  rows.push({
    label: t('deathPlace', 'Death Place'),
    detectedPerson: detectedPersonSummary?.death?.value?.place?.original,
    historicalPerson: historicalPersonSummary?.death?.value?.place?.original,
  })
  rows.push({
    label: t('deathDate', 'Death Date'),
    detectedPerson: detectedPersonSummary?.death?.value?.date?.original,
    historicalPerson: historicalPersonSummary?.death?.value?.date?.original,
  })

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('detectedPerson', 'Detected Person')}
          data={
            <>
              <PersonLink personId={detectedPersonId} personName={detectedPersonSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={detectedPersonId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DmcGrid columns={[2, 5, 5]}>
          <DataBlock heading="" data="" />
          <DataBlock heading={t('queues.historicalPerson', 'Historical Person')} data="" />
          <DataBlock heading={t('detectedPerson', 'Detected Person')} data="" />
          {rows?.map((row) => {
            return (
              <React.Fragment key={`${row.label}${row.historicalPerson}${row.detectedPerson}`}>
                <DataBlock heading={row.label} data="" />
                <DmcText text={row.historicalPerson} />
                <DmcText text={row.detectedPerson} />
              </React.Fragment>
            )
          })}
        </DmcGrid>
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DataBlock heading={t('queues.historicalType', 'Historical Type')} data={messageDetails?.historicalType} />
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DataBlock heading={t('biography', 'Biography')} data={messageDetails?.biography} />
      </Cell>

      <TreeIdCells treeId={detectedPersonSummary?.summary?.treeId} isResearcherTree="hide" />

      {/* Row */}
      <LabelsBlock personLabels={detectedPersonLabels} />
    </Grid>
  )
}
